import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../core/api.service';
import { ToastrService } from 'ngx-toastr';
import { FunctionsService } from '../../core/global/functions.service';
import { ProfileModelComponent } from 'src/app/pages/profile-model/profile-model.component';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass']
})
export class HeaderComponent implements OnInit {
  userName = 'Welcome'
  orgRefID;
  plantRefID;
  type
  notifyList = [];
  count = 0;
  showCount = 0;
  search = '';
  permit_id: any;
  eptw_id: any;
  checklist_id: any;
  incident_id: any;
accident_id: any;
  isShown: boolean = false;
  constructor(public router: Router, private _adminService: ApiService, private _functions: FunctionsService, private modalService: NgbModal) { }

  ngOnInit(): void {
    localStorage.removeItem('isShown')
    this.userName = localStorage.getItem('m_ind_name');
    this.type = window.localStorage.getItem('m_ind_type')
    if (this.type == 'orgadmin') {
      this.getOrgRefID();
    } else if (this.type == 'plantadmin') {
      this.getPlantRefID();
    }
    else if (this.type == 'plantsadmin') {
      this.getPlantRefID();
    }
    else if (this.type == 'user') {
      this.getPlantRefID();
    }
    else if (this.type == '5') {
      this.getPlantRefID();
    }
  }
  toggleShow() {
    this.isShown = !this.isShown;
    if (this.isShown == true) {
      localStorage.setItem('isShown', 'true')
    }
    if (this.isShown == false) {
      localStorage.removeItem('isShown')
    }
  }
  openModal() {
    // alert(123);
    //window.localStorage.setItem('profileAdd',id);
    const modalRef = this.modalService.open(ProfileModelComponent, { centered: true, backdrop: "static", size: 'lg' }); // xl, lg , sm
    modalRef.result.then((result) => {
      //this.getData();
    }, (reason) => {
      //
    });
  }

  redirectToHome() {
    this.router.navigateByUrl('dashboard/home');
  }
  redirectToAbout() {
    this.router.navigateByUrl('dashboard/about');
  }
  logMeOut() {
    window.localStorage.removeItem('m_ind_token');
    window.localStorage.removeItem('m_ind_name');
    window.localStorage.removeItem('m_ind_type');
    this.router.navigateByUrl('login');
  }

  getNotification() {
    let url = "notification/list"
    let id = (this.type == 'plantadmin' || this.type == 'plantsadmin' || this.type == '5' || this.type == 'user') ? this.plantRefID : this.orgRefID;
    let data = { type: this.type, id: id }
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.notifyList = response.data
        if(response.data && response.data[0]){
            this.permit_id = response.data[0].permit_id
            this.accident_id = response.data[0].accident_id
            this.eptw_id = response.data[0].eptw_id
            this.checklist_id = response.data[0].checklist_id
            this.incident_id = response.data[0].incident_id
        }
        window.localStorage.setItem('m_ind_count', this.count.toString());
      }
    })
  }

  countList() {
    let url = "notification/countlist"
    let id = (this.type == 'plantadmin' || this.type == 'plantsadmin' || this.type == '5' || this.type == 'user') ? this.plantRefID : this.orgRefID;
    let data = { type: this.type, id: id }
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.count = response.data[0].count;
        if (window.localStorage.getItem('m_ind_count') == undefined || window.localStorage.getItem('m_ind_count') == '') {
          window.localStorage.setItem('m_ind_count', this.count.toString());
        } else {
          this.showCount = this.count - parseInt(window.localStorage.getItem('m_ind_count'));
        }
      }
    })
  }

  getPlantRefID() {

    let data = {};
    let url = "plant/plantdetails";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.plantRefID = response.data[0].plant_ref_id;
        this.countList();
        // setInterval(() => {                           //<<<---using ()=> syntax
        //   this.countList();
        // }, 3000);
      }
    })
  }

  getOrgRefID() {
    let data = {};
    let url = "plant/orgdetails";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.orgRefID = response.data[0].organization_ref_id;
        this.countList();
        // setInterval(() => {                           //<<<---using ()=> syntax
        //   this.countList();
        // }, 3000);
      }
    })
  }
  checkNameChange() {
    this.userName = localStorage.getItem('m_ind_name');
  }

  timePassed(date) {
    let date_now = new Date().getTime();
    let date_future = new Date(date).getTime();

    var delta = Math.abs(date_future - date_now) / 1000;

    // calculate (and subtract) whole days
    var days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // calculate (and subtract) whole hours
    var hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    // calculate (and subtract) whole minutes
    var minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    // what's left is seconds
    var seconds = delta % 60;  // in theory the modulus is not required
    let datestring = '';
    if (days == 0 && hours == 0) {
      datestring = minutes + ' Mins ago';
    }

    if (days == 0 && hours > 0) {
      datestring = hours + ' Hour ' + minutes + ' Mins ago';
    }
    if (days > 0) {
      datestring = days + ' Day ' + hours + ' Hour ' + minutes + ' Mins ago'
    }

    return datestring;
  }
  get sortByLastModifiedDesc() {
    return this.notifyList.sort((a: any, b: any) => {
      return <any>new Date(a.created_at) - <any>new Date(b.created_at);
      
    });
  }
  get sortByLastModifiedAsend() {
    return this.notifyList.sort((a: any, b: any) => {
      return <any>new Date(b.id) - <any>new Date(a.id);
    });
  }


}
